package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Niue Flag (16x12dp)
 *
 * - ISO Alpha-2: NU
 * - ISO Alpha-3: NIU
 * - ISO Numeric: 570
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.Niue: ImageVector by lazy {
    ImageVector.Builder(
        name = "Niue:NU:NIU:570:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        }
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(0f)
                horizontalLineTo(0f)
                close()
            }
        ) {
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(0f, 8f)
                verticalLineTo(12f)
                horizontalLineTo(16f)
                verticalLineTo(8f)
                horizontalLineTo(0f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(-1.131f, 7.565f)
                lineTo(2.04f, 8.298f)
                lineTo(8.801f, 4.563f)
                lineTo(9.516f, 4.145f)
                lineTo(15.938f, 0.787f)
                lineTo(17.459f, -0.274f)
                lineTo(13.979f, -0.595f)
                lineTo(8.369f, 2.57f)
                lineTo(4.314f, 4.563f)
                lineTo(-1.131f, 7.565f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(-0.852f, 8.009f)
                lineTo(0.855f, 8.569f)
                lineTo(16.824f, -0.407f)
                horizontalLineTo(14.427f)
                lineTo(-0.852f, 8.009f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(17.185f, 7.365f)
                lineTo(17.311f, 8.12f)
                lineTo(13.96f, 8.298f)
                lineTo(8.557f, 5.134f)
                lineTo(8.047f, 5.308f)
                lineTo(-2.04f, 0.205f)
                lineTo(2.125f, -0.596f)
                lineTo(7.693f, 2.48f)
                lineTo(12.048f, 4.584f)
                lineTo(17.185f, 7.365f)
                close()
            }
            path(fill = SolidColor(Color(0xFFF50100))) {
                moveTo(17.197f, 7.819f)
                lineTo(15.489f, 8.379f)
                lineTo(8.689f, 4.535f)
                lineTo(6.673f, 4.106f)
                lineTo(-1.629f, -0.269f)
                horizontalLineTo(0.768f)
                lineTo(9.066f, 4.002f)
                lineTo(11.27f, 4.517f)
                lineTo(17.197f, 7.819f)
                close()
            }
            path(fill = SolidColor(Color.White)) {
                moveTo(6.595f, -0.625f)
                verticalLineTo(-1.25f)
                horizontalLineTo(5.97f)
                verticalLineTo(-0.625f)
                horizontalLineTo(6.595f)
                close()
                moveTo(6.595f, 2.375f)
                verticalLineTo(3f)
                horizontalLineTo(7.22f)
                verticalLineTo(2.375f)
                horizontalLineTo(6.595f)
                close()
                moveTo(-0.625f, 2.375f)
                verticalLineTo(1.75f)
                horizontalLineTo(-1.25f)
                verticalLineTo(2.375f)
                horizontalLineTo(-0.625f)
                close()
                moveTo(-0.625f, 5.625f)
                horizontalLineTo(-1.25f)
                verticalLineTo(6.25f)
                horizontalLineTo(-0.625f)
                verticalLineTo(5.625f)
                close()
                moveTo(6.595f, 5.625f)
                horizontalLineTo(7.22f)
                verticalLineTo(5f)
                horizontalLineTo(6.595f)
                verticalLineTo(5.625f)
                close()
                moveTo(6.595f, 9.625f)
                horizontalLineTo(5.97f)
                verticalLineTo(10.25f)
                horizontalLineTo(6.595f)
                verticalLineTo(9.625f)
                close()
                moveTo(9.439f, 9.625f)
                verticalLineTo(10.25f)
                horizontalLineTo(10.064f)
                verticalLineTo(9.625f)
                horizontalLineTo(9.439f)
                close()
                moveTo(9.439f, 5.625f)
                verticalLineTo(5f)
                horizontalLineTo(8.814f)
                verticalLineTo(5.625f)
                horizontalLineTo(9.439f)
                close()
                moveTo(16.625f, 5.625f)
                verticalLineTo(6.25f)
                horizontalLineTo(17.25f)
                verticalLineTo(5.625f)
                horizontalLineTo(16.625f)
                close()
                moveTo(16.625f, 2.375f)
                horizontalLineTo(17.25f)
                verticalLineTo(1.75f)
                horizontalLineTo(16.625f)
                verticalLineTo(2.375f)
                close()
                moveTo(9.439f, 2.375f)
                horizontalLineTo(8.814f)
                verticalLineTo(3f)
                horizontalLineTo(9.439f)
                verticalLineTo(2.375f)
                close()
                moveTo(9.439f, -0.625f)
                horizontalLineTo(10.064f)
                verticalLineTo(-1.25f)
                horizontalLineTo(9.439f)
                verticalLineTo(-0.625f)
                close()
                moveTo(8.189f, 2.375f)
                verticalLineTo(3f)
                horizontalLineTo(8.814f)
                verticalLineTo(2.375f)
                horizontalLineTo(8.189f)
                close()
                moveTo(8.189f, 0.625f)
                horizontalLineTo(8.814f)
                verticalLineTo(0f)
                horizontalLineTo(8.189f)
                verticalLineTo(0.625f)
                close()
                moveTo(7.845f, 0.625f)
                verticalLineTo(0f)
                horizontalLineTo(7.22f)
                verticalLineTo(0.625f)
                horizontalLineTo(7.845f)
                close()
                moveTo(7.845f, 2.375f)
                horizontalLineTo(7.22f)
                verticalLineTo(3f)
                horizontalLineTo(7.845f)
                verticalLineTo(2.375f)
                close()
                moveTo(8.189f, 3.625f)
                horizontalLineTo(8.814f)
                verticalLineTo(3f)
                horizontalLineTo(8.189f)
                verticalLineTo(3.625f)
                close()
                moveTo(7.845f, 3.625f)
                verticalLineTo(3f)
                horizontalLineTo(7.22f)
                verticalLineTo(3.625f)
                horizontalLineTo(7.845f)
                close()
                moveTo(8.189f, 4.375f)
                verticalLineTo(5f)
                horizontalLineTo(8.814f)
                verticalLineTo(4.375f)
                horizontalLineTo(8.189f)
                close()
                moveTo(7.845f, 4.375f)
                horizontalLineTo(7.22f)
                verticalLineTo(5f)
                horizontalLineTo(7.845f)
                verticalLineTo(4.375f)
                close()
                moveTo(6.595f, 3.625f)
                horizontalLineTo(7.22f)
                verticalLineTo(3f)
                horizontalLineTo(6.595f)
                verticalLineTo(3.625f)
                close()
                moveTo(0.625f, 3.625f)
                verticalLineTo(3f)
                horizontalLineTo(0f)
                verticalLineTo(3.625f)
                horizontalLineTo(0.625f)
                close()
                moveTo(0.625f, 4.375f)
                horizontalLineTo(0f)
                verticalLineTo(5f)
                horizontalLineTo(0.625f)
                verticalLineTo(4.375f)
                close()
                moveTo(6.595f, 4.375f)
                verticalLineTo(5f)
                horizontalLineTo(7.22f)
                verticalLineTo(4.375f)
                horizontalLineTo(6.595f)
                close()
                moveTo(7.845f, 5.625f)
                verticalLineTo(5f)
                horizontalLineTo(7.22f)
                verticalLineTo(5.625f)
                horizontalLineTo(7.845f)
                close()
                moveTo(7.845f, 8.375f)
                horizontalLineTo(7.22f)
                verticalLineTo(9f)
                horizontalLineTo(7.845f)
                verticalLineTo(8.375f)
                close()
                moveTo(8.189f, 8.375f)
                verticalLineTo(9f)
                horizontalLineTo(8.814f)
                verticalLineTo(8.375f)
                horizontalLineTo(8.189f)
                close()
                moveTo(8.189f, 5.625f)
                horizontalLineTo(8.814f)
                verticalLineTo(5f)
                horizontalLineTo(8.189f)
                verticalLineTo(5.625f)
                close()
                moveTo(9.439f, 3.625f)
                verticalLineTo(3f)
                horizontalLineTo(8.814f)
                verticalLineTo(3.625f)
                horizontalLineTo(9.439f)
                close()
                moveTo(9.439f, 4.375f)
                horizontalLineTo(8.814f)
                verticalLineTo(5f)
                horizontalLineTo(9.439f)
                verticalLineTo(4.375f)
                close()
                moveTo(15.375f, 3.625f)
                horizontalLineTo(16f)
                verticalLineTo(3f)
                horizontalLineTo(15.375f)
                verticalLineTo(3.625f)
                close()
                moveTo(15.375f, 4.375f)
                verticalLineTo(5f)
                horizontalLineTo(16f)
                verticalLineTo(4.375f)
                horizontalLineTo(15.375f)
                close()
                moveTo(6.595f, 0f)
                horizontalLineTo(7.22f)
                verticalLineTo(-1.25f)
                horizontalLineTo(6.595f)
                verticalLineTo(0f)
                close()
                moveTo(7.22f, 0f)
                verticalLineTo(-0.625f)
                horizontalLineTo(5.97f)
                verticalLineTo(0f)
                horizontalLineTo(7.22f)
                close()
                moveTo(7.22f, 2.375f)
                verticalLineTo(0f)
                horizontalLineTo(5.97f)
                verticalLineTo(2.375f)
                horizontalLineTo(7.22f)
                close()
                moveTo(0f, 3f)
                horizontalLineTo(6.595f)
                verticalLineTo(1.75f)
                horizontalLineTo(0f)
                verticalLineTo(3f)
                close()
                moveTo(-0.625f, 3f)
                horizontalLineTo(0f)
                verticalLineTo(1.75f)
                horizontalLineTo(-0.625f)
                verticalLineTo(3f)
                close()
                moveTo(0f, 3f)
                verticalLineTo(2.375f)
                horizontalLineTo(-1.25f)
                verticalLineTo(3f)
                horizontalLineTo(0f)
                close()
                moveTo(0f, 5f)
                verticalLineTo(3f)
                horizontalLineTo(-1.25f)
                verticalLineTo(5f)
                horizontalLineTo(0f)
                close()
                moveTo(0f, 5.625f)
                verticalLineTo(5f)
                horizontalLineTo(-1.25f)
                verticalLineTo(5.625f)
                horizontalLineTo(0f)
                close()
                moveTo(0f, 5f)
                horizontalLineTo(-0.625f)
                verticalLineTo(6.25f)
                horizontalLineTo(0f)
                verticalLineTo(5f)
                close()
                moveTo(6.595f, 5f)
                horizontalLineTo(0f)
                verticalLineTo(6.25f)
                horizontalLineTo(6.595f)
                verticalLineTo(5f)
                close()
                moveTo(7.22f, 9f)
                verticalLineTo(5.625f)
                horizontalLineTo(5.97f)
                verticalLineTo(9f)
                horizontalLineTo(7.22f)
                close()
                moveTo(7.22f, 9.625f)
                verticalLineTo(9f)
                horizontalLineTo(5.97f)
                verticalLineTo(9.625f)
                horizontalLineTo(7.22f)
                close()
                moveTo(7.22f, 9f)
                horizontalLineTo(6.595f)
                verticalLineTo(10.25f)
                horizontalLineTo(7.22f)
                verticalLineTo(9f)
                close()
                moveTo(8.814f, 9f)
                horizontalLineTo(7.22f)
                verticalLineTo(10.25f)
                horizontalLineTo(8.814f)
                verticalLineTo(9f)
                close()
                moveTo(9.439f, 9f)
                horizontalLineTo(8.814f)
                verticalLineTo(10.25f)
                horizontalLineTo(9.439f)
                verticalLineTo(9f)
                close()
                moveTo(8.814f, 9f)
                verticalLineTo(9.625f)
                horizontalLineTo(10.064f)
                verticalLineTo(9f)
                horizontalLineTo(8.814f)
                close()
                moveTo(8.814f, 5.625f)
                verticalLineTo(9f)
                horizontalLineTo(10.064f)
                verticalLineTo(5.625f)
                horizontalLineTo(8.814f)
                close()
                moveTo(16f, 5f)
                horizontalLineTo(9.439f)
                verticalLineTo(6.25f)
                horizontalLineTo(16f)
                verticalLineTo(5f)
                close()
                moveTo(16.625f, 5f)
                horizontalLineTo(16f)
                verticalLineTo(6.25f)
                horizontalLineTo(16.625f)
                verticalLineTo(5f)
                close()
                moveTo(16f, 5f)
                verticalLineTo(5.625f)
                horizontalLineTo(17.25f)
                verticalLineTo(5f)
                horizontalLineTo(16f)
                close()
                moveTo(16f, 3f)
                verticalLineTo(5f)
                horizontalLineTo(17.25f)
                verticalLineTo(3f)
                horizontalLineTo(16f)
                close()
                moveTo(16f, 2.375f)
                verticalLineTo(3f)
                horizontalLineTo(17.25f)
                verticalLineTo(2.375f)
                horizontalLineTo(16f)
                close()
                moveTo(16f, 3f)
                horizontalLineTo(16.625f)
                verticalLineTo(1.75f)
                horizontalLineTo(16f)
                verticalLineTo(3f)
                close()
                moveTo(9.439f, 3f)
                horizontalLineTo(16f)
                verticalLineTo(1.75f)
                horizontalLineTo(9.439f)
                verticalLineTo(3f)
                close()
                moveTo(8.814f, 0f)
                verticalLineTo(2.375f)
                horizontalLineTo(10.064f)
                verticalLineTo(0f)
                horizontalLineTo(8.814f)
                close()
                moveTo(8.814f, -0.625f)
                verticalLineTo(0f)
                horizontalLineTo(10.064f)
                verticalLineTo(-0.625f)
                horizontalLineTo(8.814f)
                close()
                moveTo(8.814f, 0f)
                horizontalLineTo(9.439f)
                verticalLineTo(-1.25f)
                horizontalLineTo(8.814f)
                verticalLineTo(0f)
                close()
                moveTo(7.22f, 0f)
                horizontalLineTo(8.814f)
                verticalLineTo(-1.25f)
                horizontalLineTo(7.22f)
                verticalLineTo(0f)
                close()
                moveTo(8.814f, 2.375f)
                verticalLineTo(0.625f)
                horizontalLineTo(7.564f)
                verticalLineTo(2.375f)
                horizontalLineTo(8.814f)
                close()
                moveTo(8.189f, 0f)
                horizontalLineTo(7.845f)
                verticalLineTo(1.25f)
                horizontalLineTo(8.189f)
                verticalLineTo(0f)
                close()
                moveTo(7.22f, 0.625f)
                verticalLineTo(2.375f)
                horizontalLineTo(8.469f)
                verticalLineTo(0.625f)
                horizontalLineTo(7.22f)
                close()
                moveTo(7.845f, 3f)
                horizontalLineTo(8.189f)
                verticalLineTo(1.75f)
                horizontalLineTo(7.845f)
                verticalLineTo(3f)
                close()
                moveTo(8.189f, 3f)
                horizontalLineTo(7.845f)
                verticalLineTo(4.25f)
                horizontalLineTo(8.189f)
                verticalLineTo(3f)
                close()
                moveTo(8.814f, 4.375f)
                verticalLineTo(3.625f)
                horizontalLineTo(7.564f)
                verticalLineTo(4.375f)
                horizontalLineTo(8.814f)
                close()
                moveTo(7.845f, 5f)
                horizontalLineTo(8.189f)
                verticalLineTo(3.75f)
                horizontalLineTo(7.845f)
                verticalLineTo(5f)
                close()
                moveTo(7.22f, 3.625f)
                verticalLineTo(4.375f)
                horizontalLineTo(8.469f)
                verticalLineTo(3.625f)
                horizontalLineTo(7.22f)
                close()
                moveTo(6.595f, 3f)
                horizontalLineTo(0.625f)
                verticalLineTo(4.25f)
                horizontalLineTo(6.595f)
                verticalLineTo(3f)
                close()
                moveTo(0f, 3.625f)
                verticalLineTo(4.375f)
                horizontalLineTo(1.25f)
                verticalLineTo(3.625f)
                horizontalLineTo(0f)
                close()
                moveTo(0.625f, 5f)
                horizontalLineTo(6.595f)
                verticalLineTo(3.75f)
                horizontalLineTo(0.625f)
                verticalLineTo(5f)
                close()
                moveTo(7.22f, 4.375f)
                verticalLineTo(3.625f)
                horizontalLineTo(5.97f)
                verticalLineTo(4.375f)
                horizontalLineTo(7.22f)
                close()
                moveTo(7.22f, 5.625f)
                verticalLineTo(8.375f)
                horizontalLineTo(8.469f)
                verticalLineTo(5.625f)
                horizontalLineTo(7.22f)
                close()
                moveTo(7.845f, 9f)
                horizontalLineTo(8.189f)
                verticalLineTo(7.75f)
                horizontalLineTo(7.845f)
                verticalLineTo(9f)
                close()
                moveTo(8.814f, 8.375f)
                verticalLineTo(5.625f)
                horizontalLineTo(7.564f)
                verticalLineTo(8.375f)
                horizontalLineTo(8.814f)
                close()
                moveTo(8.189f, 5f)
                horizontalLineTo(7.845f)
                verticalLineTo(6.25f)
                horizontalLineTo(8.189f)
                verticalLineTo(5f)
                close()
                moveTo(8.814f, 3.625f)
                verticalLineTo(4.375f)
                horizontalLineTo(10.064f)
                verticalLineTo(3.625f)
                horizontalLineTo(8.814f)
                close()
                moveTo(15.375f, 3f)
                horizontalLineTo(9.439f)
                verticalLineTo(4.25f)
                horizontalLineTo(15.375f)
                verticalLineTo(3f)
                close()
                moveTo(16f, 4.375f)
                verticalLineTo(3.625f)
                horizontalLineTo(14.75f)
                verticalLineTo(4.375f)
                horizontalLineTo(16f)
                close()
                moveTo(9.439f, 5f)
                horizontalLineTo(15.375f)
                verticalLineTo(3.75f)
                horizontalLineTo(9.439f)
                verticalLineTo(5f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF50100)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.846f, -0.667f)
                horizontalLineTo(7.154f)
                verticalLineTo(3f)
                horizontalLineTo(0f)
                verticalLineTo(5f)
                horizontalLineTo(7.154f)
                verticalLineTo(9.667f)
                horizontalLineTo(8.846f)
                verticalLineTo(5f)
                horizontalLineTo(17f)
                verticalLineTo(3f)
                horizontalLineTo(8.846f)
                verticalLineTo(-0.667f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFF2E42A5)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.025f, 5.3f)
                curveTo(8.784f, 5.3f, 9.4f, 4.684f, 9.4f, 3.925f)
                curveTo(9.4f, 3.166f, 8.784f, 2.55f, 8.025f, 2.55f)
                curveTo(7.266f, 2.55f, 6.65f, 3.166f, 6.65f, 3.925f)
                curveTo(6.65f, 4.684f, 7.266f, 5.3f, 8.025f, 5.3f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.05f, 4.346f)
                lineTo(7.401f, 4.797f)
                lineTo(7.63f, 4.04f)
                lineTo(7f, 3.563f)
                lineTo(7.79f, 3.547f)
                lineTo(8.05f, 2.8f)
                lineTo(8.31f, 3.547f)
                lineTo(9.1f, 3.563f)
                lineTo(8.47f, 4.04f)
                lineTo(8.699f, 4.797f)
                lineTo(8.05f, 4.346f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(3.55f, 4.288f)
                lineTo(3.009f, 4.664f)
                lineTo(3.2f, 4.034f)
                lineTo(2.675f, 3.636f)
                lineTo(3.334f, 3.622f)
                lineTo(3.55f, 3f)
                lineTo(3.766f, 3.622f)
                lineTo(4.425f, 3.636f)
                lineTo(3.9f, 4.034f)
                lineTo(4.091f, 4.664f)
                lineTo(3.55f, 4.288f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(12.55f, 4.288f)
                lineTo(12.009f, 4.664f)
                lineTo(12.2f, 4.034f)
                lineTo(11.675f, 3.636f)
                lineTo(12.334f, 3.622f)
                lineTo(12.55f, 3f)
                lineTo(12.766f, 3.622f)
                lineTo(13.425f, 3.636f)
                lineTo(12.9f, 4.034f)
                lineTo(13.091f, 4.664f)
                lineTo(12.55f, 4.288f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.05f, 1.888f)
                lineTo(7.509f, 2.264f)
                lineTo(7.7f, 1.634f)
                lineTo(7.175f, 1.236f)
                lineTo(7.834f, 1.222f)
                lineTo(8.05f, 0.6f)
                lineTo(8.266f, 1.222f)
                lineTo(8.925f, 1.236f)
                lineTo(8.4f, 1.634f)
                lineTo(8.591f, 2.264f)
                lineTo(8.05f, 1.888f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFFECA00)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(8.05f, 7.188f)
                lineTo(7.509f, 7.564f)
                lineTo(7.7f, 6.934f)
                lineTo(7.175f, 6.536f)
                lineTo(7.834f, 6.522f)
                lineTo(8.05f, 5.9f)
                lineTo(8.266f, 6.522f)
                lineTo(8.925f, 6.536f)
                lineTo(8.4f, 6.934f)
                lineTo(8.591f, 7.564f)
                lineTo(8.05f, 7.188f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun NiuePreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.Niue,
            contentDescription = "Niue Flag"
        )
    }
}
